import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, FlameIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, PRODUCT_IMAGE } from '../data/hero';
export function Hero() {
  return <header className="relative overflow-hidden bg-obsidian text-white" data-id="element-105" data-mp="9lbkfd8rfxje">
      <div className="mx-auto grid max-w-6xl gap-y-7 px-5 pb-14 pt-8 text-center lg:grid-cols-[1fr_1.1fr] lg:gap-x-12 lg:gap-y-8 lg:pb-20 lg:pt-16 lg:text-left" style={{
      paddingTop: "0px",
      paddingBottom: "10px",
      gap: "13px"
    }} data-id="element-106" data-mp="4mrsmw7hjrj4">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-107" data-mp="xb5rtfab8tw9">
          
          <h1 className="mt-4 font-display text-[46px] font-extrabold uppercase leading-[0.92] tracking-tight sm:text-6xl lg:text-[76px]" style={{
          fontSize: "36px"
        }} data-id="element-108" data-mp="s9zxxe4wz0l5">
            Train smarter.
            <br data-id="element-109" data-mp="3d33h34xud5nx" />
            Fuel better.
            <br data-id="element-110" data-mp="382ffjpbzl6fg" />
            <span className="text-electric" data-id="element-111" data-mp="381xkux4z309n">Execute with confidence.</span>
          </h1>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-white/70 sm:text-lg lg:mx-0" data-id="element-112" data-mp="3j8selyn99fos">
            One complete system to organize your entire journey from training to finish line.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-113" data-mp="399bb9nvh7dvz">
          <img src={PRODUCT_IMAGE} alt="THE FULL DISTANCE TRIATHLON SYSTEM™ on laptop with the four performance bonuses on tablets" width={1536} height={1024} fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[620px] drop-shadow-[0_30px_40px_rgba(20,125,255,0.18)]" data-id="element-114" data-mp="358hnqvly413m" />
        </motion.div>

        <div className="lg:col-start-1 lg:row-start-2" data-id="element-115" data-mp="2hk87sabey7ke">
          <p className="text-sm font-semibold text-white" data-id="element-116" data-mp="2lkqx9xpu31jf">Complete 6-Step Blueprint + 4 Performance Bonuses</p>
          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-white/60 lg:justify-start" data-id="element-117" data-mp="s1rt2qgj2avc">
            <span className="flex items-center gap-1" data-id="element-118" data-mp="na9yck53l6it">
              <span className="flex text-ember" aria-label="4.9 out of 5 stars" data-id="element-119" data-mp="ic88ngd628yd">
                {Array.from({
                length: 5
              }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-120" data-mp="degesgsyocrj" data-mpi={k} />)}
              </span>
              <span className="font-semibold text-white" data-id="element-121" data-mp="1b0dts484tzyq">4.9</span>
            </span>
            <span data-id="element-122" data-mp="16346ov87u0e2">500+ elite and amateur athletes</span>
            <span className="inline-flex items-center gap-1" data-id="element-123" data-mp="112g4reig7z52">
              <ZapIcon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-124" data-mp="110wp9q4m9s4c" /> Instant access
            </span>
          </p>

          <div className="mt-6 flex justify-center lg:justify-start" data-id="element-125" data-mp="3lsyt309hwojl">
            <CTAButton href="#pricing" data-id="element-126" data-mp="3lu9vowr7fq94">See the full system now</CTAButton>
          </div>

          <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-127" data-mp="3hpsen5c8br21">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[0.04] px-3 py-1.5 text-xs font-medium text-white/80" data-id="element-128" data-mp="21amv97jfjola">
                <Icon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-129" data-mp="26869w8k1i3dr" />
                {label}
              </li>)}
          </ul>

          <div className="mt-6 flex flex-col items-center gap-2 lg:items-start" data-id="element-130" data-mp="2g0c29je7emth">
            <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/35 bg-ember/10 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ember" data-id="element-131" data-mp="2kyvqxrk6mcpj">
              <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-132" data-mp="2oynzw5dhmkvf" />
              Limited-time offer · Price goes back up after launch
            </p>
            <p className="flex items-center gap-1.5 text-xs text-white/45" data-id="element-133" data-mp="unj1pgl670nh">
              <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-134" data-mp="zl0zcatqltg6" />
              25 people are viewing this product right now
            </p>
          </div>
        </div>
      </div>
    </header>;
}